import { NAV_ITEMS } from "@/components/sections/header/nav-config";

export default function DesktopNav({ t, scrollTo }) {
  return (
    <nav className="hidden lg:flex items-center gap-9">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.id}
          onClick={() => scrollTo(item.id)}
          data-testid={`nav-${item.id}`}
          className="link-underline text-sm font-semibold text-[var(--heading)]"
        >
          {t.nav[item.key]}
        </button>
      ))}
    </nav>
  );
}
